import {Record as record} from 'immutable';

const DatePickerRecord = record(
    {
        arriveDateText: '',
        departDateText: '',
        disabledDayAttemptedClick: '',
        datePickerPrevState: null,
        datePickerState: null,
        selectingCheckout: false,
        remountKey: false
    },
    'DatePickerRecord'
);

export default DatePickerRecord;

export {DatePickerRecord};
